import React from 'react'

interface SignInButtonProps {
  onClick: () => void
  disabled?: boolean
  isLoading?: boolean
  text: string
}

const SignInButton = ({ onClick, disabled = false, isLoading = false, text }: SignInButtonProps): JSX.Element => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={
        'self-stretch px-6 py-4 bg-blue-600 rounded-md ' +
        'inline-flex justify-center items-center gap-1.5 overflow-hidden ' +
        'hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
      }
      style={{
        boxShadow:
          '0px 0px 0px 1px rgba(53,130,206,1.00), 0px 1px 2px 0px rgba(0,89,138,1.00), inset 0px 0.75px 0px 0px rgba(255,255,255,0.20)'
      }}>
      {isLoading ? (
        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
      ) : (
        <div className="justify-start text-white text-lg font-semibold font-Montserrat leading-5">{text}</div>
      )}
    </button>
  )
}

export default SignInButton
